interface BrandLoaderProps {
  label?: string;
}

export function BrandLoader({ label }: BrandLoaderProps = {}) {
  if (document.getElementById("nk-loader")) return null;

  return (
    <div
      className="nk-react-loader fixed inset-0 z-40 flex flex-col items-center justify-center gap-7 bg-[#0F2038]"
      role="status"
      aria-label="Loading NightKept"
    >
      <style>{`
        .nk-react-loader .mark {
          width: 96px;
          height: 96px;
          overflow: visible;
        }
        .nk-react-loader .route {
          fill: none;
          stroke: #EFF2F6;
          stroke-width: 42;
          stroke-linecap: round;
          stroke-linejoin: round;
          stroke-dasharray: 1;
          stroke-dashoffset: 1;
          animation: nk-react-draw 3s ease-in-out infinite;
        }
        .nk-react-loader .node {
          fill: #EFF2F6;
          opacity: 0;
        }
        .nk-react-loader .node,
        .nk-react-loader .lamp,
        .nk-react-loader .glow {
          transform-box: fill-box;
          transform-origin: center;
        }
        .nk-react-loader .n1 {
          animation: nk-react-pop 3s ease-in-out infinite;
          animation-delay: .05s;
        }
        .nk-react-loader .n2 {
          animation: nk-react-pop 3s ease-in-out infinite;
          animation-delay: .4s;
        }
        .nk-react-loader .n3 {
          animation: nk-react-pop 3s ease-in-out infinite;
          animation-delay: .75s;
        }
        .nk-react-loader .lamp,
        .nk-react-loader .lampring {
          opacity: 0;
          animation: nk-react-ignite 3s ease-in-out infinite;
        }
        .nk-react-loader .lamp { fill: #E7A33B; }
        .nk-react-loader .lampring { fill: #0F2038; }
        .nk-react-loader .glow {
          fill: #E7A33B;
          opacity: 0;
          animation: nk-react-glow 3s ease-in-out infinite;
        }
        .nk-react-loader .label {
          color: #EFF2F6;
          font-family: 'Archivo', 'Helvetica Neue', Arial, sans-serif;
          font-size: 15px;
          letter-spacing: .3px;
          opacity: .85;
        }
        .nk-react-loader .label b { font-weight: 600; }
        .nk-react-loader .status-label {
          color: rgba(239, 242, 246, .9);
          font-family: 'Archivo', 'Helvetica Neue', Arial, sans-serif;
          font-size: 14px;
          letter-spacing: .2px;
          margin-top: -18px;
        }
        @keyframes nk-react-draw {
          0% { stroke-dashoffset: 1; opacity: 1; }
          33% { stroke-dashoffset: 0; }
          83% { stroke-dashoffset: 0; opacity: 1; }
          100% { stroke-dashoffset: 0; opacity: 0; }
        }
        @keyframes nk-react-pop {
          0%, 2% { opacity: 0; transform: scale(.4); }
          7% { opacity: 1; transform: scale(1); }
          83% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes nk-react-ignite {
          0%, 30% { opacity: 0; transform: scale(.3); }
          37% { opacity: 1; transform: scale(1.18); }
          42% { transform: scale(1); }
          83% { opacity: 1; transform: scale(1); }
          100% { opacity: 0; }
        }
        @keyframes nk-react-glow {
          0%, 30% { opacity: 0; transform: scale(.5); }
          38% { opacity: .45; transform: scale(1); }
          50% { opacity: .22; transform: scale(1.3); }
          83% { opacity: .28; transform: scale(1.15); }
          100% { opacity: 0; transform: scale(.5); }
        }
        @media (prefers-reduced-motion: reduce) {
          .nk-react-loader .route,
          .nk-react-loader .node,
          .nk-react-loader .lamp,
          .nk-react-loader .lampring,
          .nk-react-loader .glow {
            animation: none !important;
            opacity: 1;
            stroke-dashoffset: 0;
          }
          .nk-react-loader .glow { opacity: .2; }
        }
      `}</style>
      <svg className="mark" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle className="glow" cx="362" cy="150" r="54" />
        <path className="route" pathLength="1" d="M150 368 L150 150 L362 368 L362 150" />
        <circle className="node n1" cx="150" cy="368" r="25" />
        <circle className="node n2" cx="150" cy="150" r="25" />
        <circle className="node n3" cx="362" cy="368" r="25" />
        <circle className="lampring" cx="362" cy="150" r="38" />
        <circle className="lamp" cx="362" cy="150" r="29" />
      </svg>
      <div className="label"><b>NightKept</b></div>
      {label && <div className="status-label">{label}</div>}
    </div>
  );
}